const mainSearchForm = {
  flights: "Penerbangan", // translated 
  tours: "Tur", // translated 
  hotel: "Hotel", // translated 
  hotels: "Hotel", // translated 
  services: "Jasa", // translated 
  search: "MENCARI", // translated 
  destination: "Tujuan", // translated 
  includedServices: "Layanan yang Disertakan", // translated 
  packageDuration: "Durasi Paket", // translated 
  checkInOut: "Lapor masuk/keluar", // translated 
  guests: "Tamu", // translated 
  adults: "Dewasa", // translated 
  children: "Anak-anak", // translated 
  child: "Anak", // translated 
  age: "Usia", // translated 
  yearsOld: "Tahun", // translated 
  rooms: "Kamar", // translated 
  close: "Menutup", // translated 
  searchType: "Jenis Pencarian", // translated 
  accommodation: "Akomodasi", // translated 
  transfers: "Transfer", // translated 
  toursExperiences: "Tur/Pengalaman", // translated 
  nights: "malam", // translated 
  days: "hari", // translated 
  packageType: "Jenis Paket", // translated 
  tourType: "Jenis Tur", // translated 
  packages: "Paket", // translated 
  cars: "Mobil", // translated 
  cruises: "kapal pesiar", // translated 
  infantsInSeat: "Bayi di kursi", // translated 
  infantsOnLap: "Bayi di pangkuan", // translated 
  airport: "Bandara", // translated 
  passengers: "Penumpang", // translated 
  departureReturn: "Tanggal Keberangkatan dan Kepulangan", // translated 
  origin: "Asal", // translated 
  roundTrip: "Perjalanan pulang pergi", // translated 
  isRoundTrip: "Apakah Perjalanan Pulang Pergi", // translated 
  dream_packages: "Paket Impian", // translated 
  partying: "Berpesta", // translated 
  thingsToDo: "Hal yang harus dilakukan", // translated 
};



export default mainSearchForm;
